import React from "react";
import { useNavigate } from "react-router-dom";

function Card({
  id,
  type,
  date,
  title,
  subtitle,
  tags = [],
  companyName,
  tipsIncluded,
  transportationProvided,
  username,
}) {
  const navigate = useNavigate();
  const isJob = type === "jobs" || type === "job";

  const handleClick = () => {
    navigate(`/detail/${type}/${id}`);
  };

  return (
    <div className='p-6 border-2 rounded-lg mb-4 relative hover:border-blue-200 transition-colors'>
      {/* Date */}
      <div className='inline-block px-3 py-1 border rounded-md text-sm mb-3 font-architects-daughter'>
        {date}
      </div>

      {/* Content Container */}
      <div className='pr-24'>
        {/* Company Name and Title for Jobs */}
        {isJob ? (
          <div className='mb-4'>
            <h2 className='text-2xl font-bold font-architects-daughter mb-1'>
              {companyName}
            </h2>
            <h3 className='text-xl font-architects-daughter text-gray-700'>
              {title}
            </h3>
          </div>
        ) : (
          <div className='mb-4'>
            <h2 className='text-2xl font-bold font-architects-daughter mb-1'>
              {companyName}
            </h2>
            <p className='text-lg font-architects-daughter text-gray-600'>
              {subtitle}
            </p>
          </div>
        )}

        {/* Tags */}
        <div className='flex flex-wrap gap-2 mb-2'>
          {tags.map((tag, index) => (
            <span
              key={index}
              className='px-3 py-1 border rounded-full text-sm font-architects-daughter'>
              {tag}
            </span>
          ))}
          {tipsIncluded && (
            <span className='px-3 py-1 border rounded-full text-sm font-architects-daughter'>
              Tips Included
            </span>
          )}
          {transportationProvided && (
            <span className='px-3 py-1 border rounded-full text-sm font-architects-daughter'>
              Transportation Provided
            </span>
          )}
        </div>
      </div>

      {/* Details Button */}
      <button
        onClick={handleClick}
        className='absolute top-1/2 -translate-y-1/2 right-4 px-4 py-1 border-2 rounded-md border-blue-400 hover:border-blue-300 font-architects-daughter'>
        details
      </button>
    </div>
  );
}

export default Card;
